import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Baseproperties } from 'src/app/views/utility/baseproperties';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class FinancialyearService {

  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + "/common"
  constructor(private httpClient: HttpClient, private route: Router) { }

  getFinancialYearData(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/financialyear/getdata`);
  }

  modifyYear(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/financialyear/modify`, payload);
  }

  addYear(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/financialyear/add`, payload);
  }

  getModify(yearId): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/financialyear/getmodify/${yearId}`);
  }

  getConfiguration(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/financialyear/getconfiguration`);
  }
}
